"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyFormat = exports.sumTotals = exports.validateDecimalPlaces = exports.isNegative = void 0;
var isNegative = function (val) { return !!val && val < 0; };
exports.isNegative = isNegative;
var validateDecimalPlaces = function (str) {
    return str.indexOf('.') >= 0 ? str.substr(0, str.indexOf('.')) + str.substr(str.indexOf('.'), 3) : str;
};
exports.validateDecimalPlaces = validateDecimalPlaces;
var sumTotals = function (premium, state, stamping, misc) { return (premium || 0) + (state || 0) + (stamping || 0) + (misc || 0); };
exports.sumTotals = sumTotals;
var currencyFormat = function (num) {
    return num ? new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(num) : '00.00';
};
exports.currencyFormat = currencyFormat;
//# sourceMappingURL=index.js.map